import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { constants } from "./constants/common";

const RouteWatcher = () => {
    const location = useLocation();
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch({
            type: constants.RESET_QUERY,
        });
    }, [location.pathname]);  // Jab URL change hota hai

    return null;
};

export default RouteWatcher;
